__turbopack_context__.v({
  "container": "metabolic-health-assessment-client-module__5VGndG__container",
  "content": "metabolic-health-assessment-client-module__5VGndG__content",
  "ctaBar": "metabolic-health-assessment-client-module__5VGndG__ctaBar",
  "subContent": "metabolic-health-assessment-client-module__5VGndG__subContent",
});
